'use client';

import SidebarPDP from 'components/commercetools-ui/organisms/product/product-details/components/sidebar';

const PDPSidebarTastic = () => {

  return <SidebarPDP />;
};

export default PDPSidebarTastic;